<template>
  <div class="wrap">
    <div class="title-header">条件选股</div>
    <div class="mb">
      <el-dropdown
        class="mb"
        ref="queryDropdown"
        style="width: 100%"
        trigger="manual"
        placement="bottom-start"
      >
        <div class="el-dropdown-link" style="width: 100%">
          <el-input
            ref="queryTextarea"
            style="width: 100%"
            :autosize="{ minRows: 2 }"
            placeholder="请输入内容"
            type="textarea"
            v-model="queryCondition"
            @input="handleQueryInput"
            @focus="handleTextareaFocus"
          ></el-input>
        </div>
        <el-dropdown-menu slot="dropdown" v-show="querySuggestions.length > 0">
          <el-dropdown-item
            v-for="(item, index) in querySuggestions"
            :key="index"
            @click.native="handleSelectSuggestion(item)"
          >
            {{ item.suggestQuery }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="flex">
        <el-button
          type="primary"
          size="mini"
          plain
          class="mb"
          @click="submitStockCondition"
          :loading="isFetchingStockCondition"
          :disabled="isFetchingStockCondition"
        >
          查询
        </el-button>
      </div>

      <!-- 历史查询列表  最近5条数据 -->
      <div class="history-query-list mb" v-if="queryHistory.length > 0">
        <div class="history-title">历史查询</div>
        <div class="history-items">
          <el-tag
            v-for="(item, index) in queryHistory"
            :key="index"
            class="history-tag"
            effect="plain"
            type="success"
            size="medium"
            @click="selectHistoryQuery(item)"
            :closable="true"
            @close="removeHistoryQuery(index)"
          >
            {{ item }}
          </el-tag>
        </div>
      </div>
    </div>
    <el-table
      :data="stockList"
      :border="true"
      max-height="800"
      style="width: 100%"
      :header-cell-style="{ color: '#292d39' }"
      class="mb data-table"
      v-if="tableColumns.length > 0"
    >
      <!-- 股票名称和代码合并列 -->
      <el-table-column type="index" label="序号">
        <template slot="header">
          <div>
            序号
            <br />
            {{ stockList.length }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="股票" align="center" min-width="120">
        <template slot-scope="scope">
          <div>
            <div style="font-weight: bold">{{ scope.row.SECURITY_SHORT_NAME || '-' }}</div>
            <div style="font-size: 12px; color: #999">{{ scope.row.SECURITY_CODE || '-' }}</div>
          </div>
        </template>
      </el-table-column>

      <!-- 动态渲染其他列（支持二级表头） -->
      <template v-for="column in tableColumns">
        <!-- 如果有子列，渲染二级表头 -->
        <el-table-column
          v-if="column.children && column.children.length > 0"
          :key="`parent-${column.key}`"
          :label="column.title"
          align="center"
        >
          <el-table-column
            v-for="child in column.children"
            :key="child.key"
            :prop="child.key"
            :label="child.dateMsg || child.title"
            :min-width="100"
            align="center"
            :sortable="child.sortable"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span :class="getCellClass(child, scope.row[child.key])">
                {{ formatCellValue(scope.row[child.key], child) }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- 如果没有子列，正常渲染 -->
        <el-table-column
          v-else
          :key="`single-${column.key}`"
          :prop="column.key"
          :label="column.title"
          :min-width="column.minWidth || 260"
          align="center"
          :sortable="column.sortable"
          show-overflow-tooltip
        >
          <template slot="header" slot-scope="scope">
            <div>
              {{ column.title }}
              <br />
              {{ column.dateMsg }}
            </div>
          </template>
          <template slot-scope="scope">
            <span :class="getCellClass(column, scope.row[column.key])">
              {{ formatCellValue(scope.row[column.key], column) }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <el-select
      v-model="stockCodes"
      placeholder="代码或名称"
      style="width: 100%; margin-top: 20px;"
      filterable
      clearable
      multiple
      remote
      :remote-method="remoteMethod"
      @change="(val) => changeCode(val)"
      class="mb"
      :loading="searchLoading"
    >
      <el-option
        v-for="(item, index) in elSelect103Options"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <div class="mb checkbox-group">
      <el-radio v-model="onlyTradingDay" :label="1" @change="changeType">只显示交易日</el-radio>
      <el-radio v-model="onlyTradingDay" @change="changeType" :label="2">显示全部日期</el-radio>
    </div>

    <!-- <el-divider></el-divider> -->

    <div class="mb" style="background-color: #fff; padding: 10px; border-radius: 4px">
      <el-checkbox-group v-model="dataType" size="mini" class="mb checkbox-group">
        <el-checkbox
          class="checkbox-item"
          v-for="(item, idx) in dateListShow"
          :key="idx"
          :label="item.date"
        >
          {{ item.date }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <!-- <el-divider></el-divider> -->

    <div class="mb">
      <el-radio-group
        class="checkbox-group"
        style="width: 100%"
        v-model="quickSelectType"
        @change="handleQuickSelect"
      >
        <el-radio :label="3">近3个交易日</el-radio>
        <el-radio :label="5">近5个交易日</el-radio>
        <el-radio :label="7">近7个交易日</el-radio>
        <el-radio :label="10">近10个交易日</el-radio>
      </el-radio-group>
    </div>

    <div class="flex mb">
      <el-button type="primary" size="mini" plain class="mb" @click="reset">重置</el-button>
      <!-- <el-button
				type="primary"
				size="mini"
				plain
				class="mb"
				@click="changeActive()"
			>全选</el-button> -->

      <el-button
        type="primary"
        size="mini"
        plain
        class="mb"
        @click="submitForm"
        :loading="isFetching"
        :disabled="isFetching"
      >
        {{ isFetching ? '查询中' : '查询' }}
      </el-button>
    </div>

    <div class="mb flex" style="display: flex; align-items: center">
      <span style="margin-right: 10px">趋势:</span>
      <el-select
        v-model="trend"
        placeholder="趋势"
        clearable
        filterable
        size="small"
        @change="handleTrendChange"
      >
        <el-option label="全部" value="" />
        <el-option label="上升 ⤴️" value="上升" />
        <el-option label="下降 ⤵️" value="下降" />
        <el-option label="严格上升 ↗️" value="严格上升" />
        <el-option label="严格下降 ↘️" value="严格下降" />
      </el-select>
      <span style="margin: 0 10px">特征:</span>
      <div style="flex: 1; display: flex; flex-direction: column; gap: 6px;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <el-input
            style="flex: 1"
            placeholder="示例：9号比6号多 | 今天比6日的一半多 | 9号比6号和5号加起来都多 | 9号比6号和5号都多 | 9号比6号和5号的平均多 | 今天比最近3天的平均多 | 第1个比第2个少 | 九号比六号多"
            v-model="userPrompt"
            size="small"
            @keyup.enter.native="parsePrompt"
            clearable
            @clear="clearFeature"
            :autosize="{ minRows: 2 }"
            type="textarea"
          ></el-input>
          <el-button type="primary" size="small" @click="parsePrompt">解析</el-button>
          <el-button size="small" @click="clearFeature" v-if="feature">清除</el-button>
        </div>
        <div v-if="parsedLabel" style="font-size: 12px; color: #67c23a;">
          已应用: {{ parsedLabel }}
        </div>
        <div v-if="parseError" style="font-size: 12px; color: #e6a23c;">
          {{ parseError }}
        </div>
        <!-- {{ feature }} -->
        <!-- 快捷选项（从已选日期自动生成） -->
        <div v-if="featureOptions.length > 0" style="display: flex; flex-wrap: wrap; gap: 4px;">
          <el-tag
            v-for="(item, index) in featureOptions"
            :key="index"
            size="mini"
            :type="feature === item.value ? 'success' : 'info'"
            effect="plain"
            style="cursor: pointer;"
            @click="applyQuickFeature(item)"
          >
            {{ item.label }}
          </el-tag>
        </div>
      </div>
    </div>

    <el-table
      :data="showTableData"
      :border="true"
      style="width: 100%; margin-bottom: 10px"
      :header-cell-style="{ color: '#292d39' }"
      class="mb data-table"
    >
      <el-table-column align="center" width="100" label="名称">
        <template slot-scope="scope">
          <div>
            {{ scope.row.stockName }}
            <br />
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" min-width="250" label="帖子">
        <template slot-scope="scope">
          <div class="bar-chart-container">
            <div v-for="(val, key) in scope.row.guba" :key="key" class="bar-chart-item">
              <div class="bar-chart-label">{{ key }}</div>
              <div class="bar-chart-wrapper">
                <div
                  class="bar-chart-bar"
                  :style="{ width: getBarWidth(val.count, scope.row.guba) + '%' }"
                >
                  <span class="bar-chart-value">{{ val.count }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" min-width="150" label="特征">
        <template slot-scope="scope">
          <div>
            {{ scope.row.trend }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// import './utildemo.js'
import { mannKendall } from './util'
import { parseUserPrompt, generateFeatureOptions as nlpGenerateFeatureOptions } from './NLP'
import tabledata from './tabledata.json'
import axios from 'axios'
import dayjs from 'dayjs'
import pLimit from 'p-limit' // 使用 p-limit 库来控制并发数量
import * as Sentry from '@sentry/vue'
const limit = pLimit(5) // 设置并发限制为 5 个请求
// 创建任务列表的辅助函数
function createTaskList(list, handler) {
  return list.map((target) =>
    limit(async () => {
      try {
        await handler(target)
      } catch (error) {
        console.log('error.message===>', error.message)
      }
    }),
  )
}

// 配置不展示的字段列表
const HIDDEN_COLUMNS = {
  SERIAL: true, // 序号
  SECURITY_CODE: true, // 股票代码（已合并到股票列）
  SECURITY_SHORT_NAME: true, // 股票名称（已合并到股票列）
  MARKET_SHORT_NAME: true, // 市场简称
  MARKET_NUM: true, // 市场码
}

const isInc = (arr) => arr.every((v, i) => i === 0 || v >= arr[i - 1])
const isDec = (arr) => arr.every((v, i) => i === 0 || v <= arr[i - 1])

const CURL_PROXY = 'https://api.niumengke.top/koa/curl'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      trend: '',
      feature: '',
      queryCondition: '',
      querySuggestions: [],
      suggestId: '',
      queryInputTimer: null,
      holidays: {},
      dataType: [],
      dateList: [],
      featureOptions: [],
      tableData2: tabledata,
      tableData: [],
      stockList: [],
      tableColumns: [],
      stockCodes: JSON.parse(localStorage.getItem('stockCodes')) || [],
      elSelect103Options: [],
      onlyTradingDay: 1,
      quickSelectType: parseInt(localStorage.getItem('quickSelectType')) || 0,
      queryHistory: JSON.parse(localStorage.getItem('queryHistory')) || [], // 历史查询记录，最多保存5条
      isFetching: false, // 防止重复查询（用于股吧帖子查询）
      isFetchingStockCondition: false, // 防止重复查询（用于条件选股查询）
      searchLoading: false, // 防止重复查询（用于股票代码搜索
      userPrompt: '',       // NLP 输入内容
      parsedLabel: '',      // 解析结果的可读标签
      parseError: '',       // 解析错误/警告信息
    }
  },
  computed: {
    isPopup() {
      return this.chrome && this.chrome.runtime
    },
    dateListShow() {
      return this.dateList.filter((item) => {
        if (this.onlyTradingDay === 1) {
          return item.isTradingDay
        } else {
          return true
        }
      })
    },
    showTableData() {
      const res1 = this.tableData.filter((item) => {
        if (this.trend) {
          return item.trend.includes(this.trend)
        } else {
          return true
        }
      })
      const res2 = res1.filter((item) => {
        if (this.feature) {
          try {
            const func = eval(`(${this.feature})`)
            const res = func(item.guba)
            return res
          } catch (error) {
            console.error('执行特征函数失败:', error, this.feature)
            return false
          }
        } else {
          return true
        }
      })
      return res2
    },
  },
  watch: {
    stockCodes: {
      handler(val) {
        localStorage.setItem('stockCodes', JSON.stringify(val || []))
      },
    },
    dataType: {
      handler(val) {
        this.generateFeatureOptions(val)
      },
      immediate: true,
    },
  },
  async created() {
    await this.getHolidays()
    await this.init()
  },
  mounted() {},
  methods: {
    changeType(t) {
      if (t == 1) {
        // 只显示交易日时，保留已选中的日期（如果还在交易日列表中）
        this.dataType = this.dateListShow
          .filter((item) => this.dataType.includes(item.date))
          .map((item) => item.date)
      } else {
        // 显示全部日期时，如果之前使用了快捷选中，重新应用
        if (this.quickSelectType) {
          this.$nextTick(() => {
            this.applyQuickSelect()
          })
        }
      }
    },

    reset() {
      this.dataType = []
      this.quickSelectType = 0
      this.handleQuickSelect(0)
    },

    changeActive() {
      this.dataType = this.dateListShow.map((item) => item.date)
    },

    async init() {
      this.dateList = this.getTradingDays()
      // 初始化后应用快捷选中
      this.$nextTick(() => {
        this.applyQuickSelect()
      })
    },

    // 处理快捷选中
    handleQuickSelect(value) {
      // 持久化快捷选中类型
      localStorage.setItem('quickSelectType', value.toString())
      // 应用快捷选中
      this.applyQuickSelect()
    },

    // 应用快捷选中
    applyQuickSelect() {
      if (!this.quickSelectType || this.dateListShow.length === 0) {
        return
      }

      // 获取最近的 N 个交易日
      const tradingDays = this.dateListShow
        .filter((item) => item.isTradingDay)
        .slice(0, this.quickSelectType)
        .map((item) => item.date)

      // 自动选中这些日期
      this.dataType = tradingDays
    },

    getTradingDays(targetLength = 15) {
      const res = []
      let date = dayjs(dayjs().format('YYYYMMDD'))

      while (res.length < targetLength) {
        const dateStr = date.format('YYYY-MM-DD')
        const info = {
          date: dateStr,
          isTradingDay: this.isTradingDay(dateStr),
        }
        res.push(info)
        date = date.subtract(1, 'day') // Move to the previous day if not a trading day
      }
      return res
    },

    isTradingDay(dateStr) {
      dateStr = dateStr || dayjs().format('YYYYMMDD')
      const date = dayjs(dateStr)
      const formattedDate = date.format('YYYYMMDD')

      // 判断是否为周六或周日
      const isWeekend = date.day() === 0 || date.day() === 6

      // 判断是否为节假日
      const isHoliday = this.holidays[formattedDate] !== undefined

      const isTrading = !isWeekend && !isHoliday
      return isTrading
    },

    async calcCount(code, targetDays = []) {
      let page = 1
      const res = {}
      // Sort targetDays to ensure we're processing in reverse chronological order
      const sortedTargetDays = targetDays.sort((a, b) => (dayjs(b).isBefore(dayjs(a)) ? 1 : -1))
      if (!sortedTargetDays.length) {
        return res
      }

      while (true) {
        const list = await this.getGubaCount(code, page++)
        if (list.length === 0) {
          break // 终止循环
        }
        // 1: 资讯 2: 研报  3: 公告  11: 问董秘
        // post_last_time 是帖子的最后回复时间，post_publish_time 是帖子的发布时间
        for (const { post_publish_time, user_id, post_last_time } of list.filter(
          (el) => ![1, 2, 3, 11].includes(el.post_type),
        )) {
          const postDay = post_publish_time.slice(0, 10)
          const postLastDay = post_last_time.slice(0, 10)

          if (sortedTargetDays[0] > postLastDay) {
            return res
          } else {
            if (sortedTargetDays.includes(postDay)) {
              res[postDay] = res[postDay] || { users: new Set(), count: 0 }

              if (!res[postDay].users.has(user_id)) {
                res[postDay].users.add(user_id)
                res[postDay].count = res[postDay].count + 1
              }
            }
          }
        }

        if (list.length < 100) {
          break
        }
      }

      return res
    },

    async getHolidays() {
      // 解析 iCalendar 数据，并提取节假日信息
      function parseICalendar(data) {
        const events = data.match(/BEGIN:VEVENT([\s\S]*?)END:VEVENT/g)
        if (events) {
          events.forEach((event) => {
            const dtStart = event.match(/DTSTART;VALUE=DATE:(\d{8})/)
            const dtEnd = event.match(/DTEND;VALUE=DATE:(\d{8})/)
            const summaryMatch = event.match(/SUMMARY;LANGUAGE=zh_CN:(.*)/)

            if (dtStart && summaryMatch && dtEnd) {
              let currentDate = dayjs(dtStart[1])
              const endDate = dayjs(dayjs(dtEnd[1]).subtract(1, 'day').format('YYYYMMDD'))
              // 在遍历日期时，包含最后一天
              while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
                // 将当前日期转成 YYYYMMDD 格式并添加到数组中
                this.holidays[currentDate.format('YYYYMMDD')] = summaryMatch[1]
                currentDate = currentDate.add(1, 'day')
              }
            }
          })
        }
      }

      // 判断某个日期是否为交易日（非周末且非节假日）
      // 原来的请求方式（注释掉，以后可能用）
      // const res = await axios.post('https://api.amazingxia.top/proxy', {
      // 	url: 'https://calendars.icloud.com/holidays/cn_zh.ics'
      // })
      // const calendars = res.data

      // 使用 capis-ecs 代理
      const curl = `curl 'https://calendars.icloud.com/holidays/cn_zh.ics'`
      const res = await axios.post(
        CURL_PROXY,
        {
          curl: curl,
        },
      )

      // 从代理返回的数据中提取实际的响应数据
      const calendars = res.data || ''
      parseICalendar.call(this, calendars)
    },

    customSortMethod(a, b) {
      return a.active === b.active ? 0 : a.active ? -1 : 1 // 让 `true` 排在 `false` 之前
    },

    // 条件选股查询
    async submitStockCondition() {
      if (!this.queryCondition || this.queryCondition.trim() === '') {
        this.$message.error('请输入查询条件')
        return
      }
      if (this.isFetchingStockCondition) return // 避免重复查询
      this.isFetchingStockCondition = true
      this.stockList = []
      this.tableColumns = []

      try {
        // 生成请求参数
        const timestamp = Date.now().toString()
        const requestId = `VYsjvvfYWNTswnfYcCjA1SHvg7jPbk0P${timestamp}`
        const fingerprint = `58e0cB8199F4-0462-42AB-8310-38947E9B8C21679A`
        const xcId = `xc0decef7f3f07010675`

        const requestData = {
          ownSelectAll: false,
          keyWord: this.queryCondition,
          pageSize: 1000,
          pageNo: 1,
          fingerprint: fingerprint,
          gids: [],
          timestamp: timestamp,
          requestId: requestId,
          shareToGuba: false,
          removedConditionIdList: [],
          xcId: xcId,
          sortName: '',
          sortWay: '',
          needCorrect: true,
          dxInfo: [],
          needShowStockNum: false,
          customData: JSON.stringify([
            {
              type: 'text',
              value: this.queryCondition,
              extra: '',
            },
          ]),
          client: '',
          product: '',
        }

        // 使用代理请求
        const curl = `curl 'https://np-tjxg-app-b.eastmoney.com/api/smart-tag/stock/v3/rn/search-code' \\
--header 'Content-Type: application/json' \\
--data '${JSON.stringify(requestData)}'`

        const res = await axios.post(
          CURL_PROXY,
          {
            curl: curl,
          },
        )

        if (res.data && res.data.code === '100' && res.data.data && res.data.data.result) {
          const result = res.data.data.result

          // 设置表格列
          if (result.columns && result.columns.length > 0) {
            this.tableColumns = result.columns
              .filter((col) => {
                // 过滤隐藏的列和配置中不展示的字段
                return !col.hiddenNeed && !HIDDEN_COLUMNS[col.key]
              })
              .map((col) => {
                // 处理有子列的列（二级表头）
                const column = {
                  key: col.key,
                  title: col.title,
                  minWidth: col.title.length * 15 + 40,
                  sortable: col.sortable || false,
                  redGreenAble: col.redGreenAble || false,
                  dataType: col.dataType,
                  unit: col.unit || '',
                  dateMsg: col.dateMsg || '',
                }

                // 如果有子列，过滤并处理子列
                if (col.children && col.children.length > 0) {
                  column.children = col.children
                    .filter((child) => !child.hiddenNeed && !HIDDEN_COLUMNS[child.key])
                    .map((child) => ({
                      key: child.key,
                      title: child.title,
                      dateMsg: child.dateMsg || '',
                      sortable: child.sortable || false,
                      redGreenAble: child.redGreenAble || false,
                      dataType: child.dataType,
                      unit: child.unit || '',
                    }))
                }

                return column
              })
          }

          // 设置表格数据
          if (result.dataList && result.dataList.length > 0) {
            this.stockList = result.dataList

            // 赋值给 this.stockCodes（格式：code:name）
            this.stockCodes = this.stockList.map((item) => {
              return `${item.SECURITY_CODE}:${item.SECURITY_SHORT_NAME}`
            })

            // 查询成功，保存到历史记录
            this.saveQueryHistory(this.queryCondition)

            // 自动调用 submitForm() 查询股吧数据
            this.$nextTick(() => {
              this.submitForm()
            })
          } else {
            this.$message.info('未查询到数据')
          }
        } else {
          this.$message.error(res.data?.msg || '查询失败')
        }
      } catch (error) {
        console.error('条件选股查询失败:', error)
        this.$message.error('查询失败')
      }
      this.isFetchingStockCondition = false
    },

    // 保存查询历史
    saveQueryHistory(query) {
      if (!query || !query.trim()) {
        return
      }

      const trimmedQuery = query.trim()

      // 移除已存在的相同查询
      this.queryHistory = this.queryHistory.filter((item) => item !== trimmedQuery)

      // 添加到最前面
      this.queryHistory.unshift(trimmedQuery)

      // 只保留最近5条
      if (this.queryHistory.length > 5) {
        this.queryHistory = this.queryHistory.slice(0, 5)
      }

      // 保存到 localStorage
      localStorage.setItem('queryHistory', JSON.stringify(this.queryHistory))
    },

    // 选择历史查询
    selectHistoryQuery(query) {
      this.queryCondition = query
      // 自动触发查询
      // this.submitStockCondition()
    },

    // 删除历史查询
    removeHistoryQuery(index) {
      this.queryHistory.splice(index, 1)
      // 保存到 localStorage
      localStorage.setItem('queryHistory', JSON.stringify(this.queryHistory))
    },

    async submitForm() {
      if (this.dataType.length === 0) {
        this.$message.error('请选择日期')
        return
      }
      if (this.stockCodes.length === 0) {
        this.$message.error('请选择股票')
        return
      }
      if (this.isFetching) return // 避免重复查询
      this.isFetching = true
      this.tableData = []
      try {
        const tasks = [
          ...createTaskList(this.stockCodes, async (target) => {
            const code = target.split(':')[0]
            const name = target.split(':')[1]

            const guBa = await this.calcCount(code, this.dataType)
            // console.log('guBa===>', guBa)
            const trend = this.calcTrend(guBa, this.dataType)
            this.tableData.push({
              stockName: name,
              guba: guBa,
              code: code,
              trend: trend,
            })
          }),
        ]

        // 执行所有任务
        await Promise.all(tasks)
        console.log('this.tableData===>', this.tableData)
      } catch (error) {
        this.$message.error('查询失败')
      }
      this.isFetching = false
    },

    // 格式化单元格值
    formatCellValue(value, column) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }

      const strValue = String(value)

      // 检查是否是涨跌幅列（通过 key 或 unit 判断）
      const isChangeRate =
        column.key && (column.key === 'CHG' || column.key.startsWith('CHG{') || column.unit === '%')

      // 如果是涨跌幅，且值不包含 %，则添加 %
      if (isChangeRate && !strValue.includes('%')) {
        // 检查是否是纯数字（可能带小数点）
        const numValue = parseFloat(strValue)
        if (!isNaN(numValue)) {
          return strValue + '%'
        }
      }

      // 直接返回字符串形式的值（接口返回的数据已经格式化好）
      return strValue
    },

    // 获取单元格样式类
    getCellClass(column, value) {
      const classes = []
      // 根据列的类型添加样式
      if (column.redGreenAble && value) {
        const numValue = parseFloat(value)
        if (!isNaN(numValue)) {
          if (numValue > 0) {
            classes.push('red')
          } else if (numValue < 0) {
            classes.push('green')
          }
        }
      }
      return classes.join(' ')
    },

    // 计算柱状图宽度百分比
    getBarWidth(count, gubaData) {
      if (!count || !gubaData) {
        return 0
      }
      // 找到所有数据中的最大值
      const maxCount = Math.max(...Object.values(gubaData).map((item) => item.count || 0))
      if (maxCount === 0) {
        return 0
      }
      // 计算当前值相对于最大值的百分比（最小宽度 5%，最大宽度 100%）
      const percentage = (count / maxCount) * 100
      return Math.max(5, Math.min(100, percentage))
    },

    async getGubaCount(code = '301366', time = 1) {
      // 一次请求2页数据
      const N = 2
      const startPage = (time - 1) * N + 1
      const endPage = time * N
      const requests = []
      for (let i = startPage; i <= endPage; i++) {
        // 原来的请求方式（注释掉，以后可能用）
        // requests.push(axios.post('https://api.amazingxia.top/proxy', {
        // 	url: `https://gbapi.eastmoney.com/webarticlelist/api/Article/WebArticleList?code=${code}&p=${i}&ps=100&sorttype=0&plat=wap&version=300&product=guba&deviceid=1`,
        // }));

        // 使用代理
        const url = `https://gbapi.eastmoney.com/webarticlelist/api/Article/WebArticleList?code=${code}&p=${i}&ps=100&sorttype=0&plat=wap&version=200&product=guba&deviceid=1`
        const curl = `curl '${url}'`
        requests.push(
          axios.post(CURL_PROXY, {
            curl: curl,
          }),
        )
      }

      const responses = await Promise.all(requests)
      const list = responses.flatMap((res) => res.data?.re || [])
      const res = list.map(({ post_type, post_publish_time, post_user, post_last_time }) => {
        return {
          post_type,
          post_publish_time,
          post_last_time,
          user_id: post_user.user_id,
        }
      })
      console.log('res===>', res)
      return res
    },

    changeCode(code) {
      if (!code) {
        this.elSelect103Options = []
      }

      this.$nextTick(() => {
        this.elSelect103Options = []
      })
    },

    async remoteMethod(query) {
      if (query !== '') {
        this.searchLoading = true
        // 原来的请求方式（注释掉，以后可能用）
        // const res = await axios.post('https://api.amazingxia.top/proxy', {
        // 	url: `https://search-codetable.eastmoney.com/codetable/search/web/wap?label=&keyword=${query}&pageIndex=1&pageSize=20&client=wap&clientType=wapSearch&clientVersion=lastest&_=${Date.now()}`,
        // })

        // 使用 capis-ecs 代理
        const url = `https://search-codetable.eastmoney.com/codetable/search/web/wap?label=&keyword=${query}&pageIndex=1&pageSize=20&client=wap&clientType=wapSearch&clientVersion=lastest&_=${Date.now()}`
        const curl = `curl '${url}'`
        const res = await axios.post(
          CURL_PROXY,
          {
            curl: curl,
          },
        )

        const list = res.data?.result?.quoteList || res.data?.data?.result?.quoteList || []
        this.elSelect103Options = list.map((item) => {
          const label = item.shortName.replace(/<\/?em>/g, '')
          const val = `${item.code}`.replace(/<\/?em>/g, '')
          return {
            label: `${val}:${label}`,
            // value: item.market + '.' + `${item.code}`.replace(/<\/?em>/g, '')
            value: `${val}:${label}`,
          }
        })
        this.searchLoading = false
      } else {
        this.elSelect103Options = []
        this.searchLoading = false
      }
    },

    // 安全地隐藏下拉菜单
    safeHideDropdown() {
      try {
        const dropdown = this.$refs.queryDropdown
        if (dropdown) {
          // 如果已经包装过，直接调用
          if (dropdown.triggerElm) {
            dropdown.hide()
          }
        }
      } catch (error) {
        // 忽略错误，组件可能还未完全初始化
        console.warn('隐藏下拉菜单失败:', error)
      }
    },

    // 安全地显示下拉菜单
    safeShowDropdown() {
      try {
        const dropdown = this.$refs.queryDropdown
        if (dropdown && dropdown.triggerElm) {
          dropdown.show()
        }
      } catch (error) {
        // 忽略错误，组件可能还未完全初始化
        console.warn('显示下拉菜单失败:', error)
      }
    },

    // 处理 textarea 输入
    handleQueryInput(value) {
      // 防抖处理
      if (this.queryInputTimer) {
        clearTimeout(this.queryInputTimer)
      }

      if (!value || value.trim() === '') {
        this.querySuggestions = []
        this.safeHideDropdown()
        return
      }

      this.queryInputTimer = setTimeout(() => {
        this.fetchQuerySuggestions(value)
      }, 300)
    },

    // 处理 textarea 获得焦点
    handleTextareaFocus() {
      if (this.querySuggestions.length > 0) {
        this.$nextTick(() => {
          this.safeShowDropdown()
        })
      }
    },

    // 获取查询建议
    async fetchQuerySuggestions(query) {
      try {
        // const res = await axios.post('https://api.amazingxia.top/proxy', {
        // 	url: 'https://query-suggestion.eastmoney.com/search/stock/querySuggest',
        // 	method: 'POST',
        // 	headers: {
        // 		'Content-Type': 'application/json'
        // 	},
        // 	data: {
        // 		query: query,
        // 		limit: 5,
        // 		clientType: 'RN',
        // 		clientVersion: '10036000',
        // 		client: 'cfw',
        // 		uid: '9655085394568108',
        // 		euid: '5B8199F4-0462-42AB-8310-38947E9B8C2A',
        // 		sessionId: '3070844537738192'
        // 	}
        // });

        const curl = `curl 'https://query-suggestion.eastmoney.com/search/stock/querySuggest' \
--header 'Content-Type: application/json' \
--data '{"query":"${query}","limit":5,"clientType":"RN","clientVersion":"10036000","client":"cfw","uid":"9655085394568108","euid":"5B8199F4-0462-42AB-8310-38947E9B8C2A","sessionId":"3070844537738192"}'`

        const res = await axios.post(
          CURL_PROXY,
          {
            curl: curl,
          },
        )

        if (res.data && res.data.code === '00000' && res.data.data) {
          this.querySuggestions = res.data.data.matchQuery || []
          this.suggestId = res.data.data.suggestId || ''

          // 如果有建议，显示下拉菜单
          if (this.querySuggestions.length > 0) {
            this.$nextTick(() => {
              this.safeShowDropdown()
            })
          } else {
            this.safeHideDropdown()
          }
        } else {
          this.querySuggestions = []
          this.safeHideDropdown()
        }
      } catch (error) {
        console.error('获取查询建议失败:', error)
        this.querySuggestions = []
        this.safeHideDropdown()
      }
    },

    // 处理选择建议
    handleSelectSuggestion(item) {
      if (!item || !item.suggestQuery) {
        return
      }

      const currentText = this.queryCondition
      const begin = item.begin || 0
      const end = item.end || currentText.length

      // 替换指定位置的文本
      const beforeText = currentText.substring(0, begin)
      const afterText = currentText.substring(end)
      const newText = beforeText + item.suggestQuery + afterText

      this.queryCondition = newText

      // 清空下拉菜单
      this.querySuggestions = []
      this.safeHideDropdown()

      // 将光标移动到替换文本的末尾
      this.$nextTick(() => {
        // 通过 ref 获取 el-input 组件，然后找到内部的 textarea
        const inputComponent = this.$refs.queryTextarea
        if (inputComponent) {
          const textarea = inputComponent.$el ? inputComponent.$el.querySelector('textarea') : null
          if (textarea) {
            const cursorPosition = begin + item.suggestQuery.length
            textarea.setSelectionRange(cursorPosition, cursorPosition)
            textarea.focus()
          }
        }
      })
    },

    /**
     * 根据 dataType 生成 featureOptions（使用 NLP 模块）
     */
    generateFeatureOptions(dataType) {
      this.featureOptions = nlpGenerateFeatureOptions(dataType)
    },

    /**
     * 解析用户输入的自然语言，生成过滤函数
     */
    parsePrompt() {
      if (!this.userPrompt || !this.userPrompt.trim()) {
        this.clearFeature()
        return
      }

      const result = parseUserPrompt(this.userPrompt, this.dataType)

      if (result.feature) {
        this.feature = result.feature
        this.parsedLabel = result.label
        this.parseError = result.error || ''  // 可能有警告
      } else {
        this.feature = ''
        this.parsedLabel = ''
        this.parseError = result.error || '解析失败'
      }
    },

    /**
     * 清除特征过滤
     */
    clearFeature() {
      this.feature = ''
      this.userPrompt = ''
      this.parsedLabel = ''
      this.parseError = ''
    },

    /**
     * 点击快捷标签直接应用
     */
    applyQuickFeature(item) {
      if (this.feature === item.value) {
        // 再次点击取消
        this.feature = ''
        this.parsedLabel = ''
        this.userPrompt = ''
      } else {
        this.feature = item.value
        this.parsedLabel = item.label
        this.userPrompt = item.label
        this.parseError = ''
      }
    },

    calcTrend(guBa, dataType) {
      const arr = Object.values(guBa)
        .map((item) => item.count)
        .reverse()
      const result = mannKendall(arr)

      let trend = ''

      if (Math.abs(result.Z) > 1.65) {
        if (result.Z > 0) {
          trend = '上升 ⤴️'
        } else {
          trend = '下降 ⤵️'
        }
      }

      if (result.trend === 'increasing') {
        trend = '严格上升 ↗️'
      } else if (result.trend === 'decreasing') {
        trend = '严格下降 ↘️'
      }

      return trend
    },

    handleTrendChange(value) {
      this.trend = value
      // Sentry 埋点上报
      Sentry.captureMessage(this.queryCondition + value, {
        level: 'info',
        extra: {
          trend: value,
          queryCondition: this.queryCondition,
        },
      })
    },

    handleFeatureChange(value) {
      this.feature = value
      // Sentry 埋点上报
      Sentry.captureMessage(this.queryCondition + value, {
        level: 'info',
        extra: {
          feature: value,
          queryCondition: this.queryCondition,
        },
      })
    },
  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  padding-bottom: 120px;
}

.wrap {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  padding: 12px;
  overflow: hidden;
  box-sizing: border-box;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .wrap {
    max-width: 100%;
    padding: 0 10px;
  }
}

/* 平板端适配 */
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .wrap {
    max-width: 800px;
    padding: 0 20px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1424px) {
  .wrap {
    max-width: 900px;
    padding: 0 20px;
  }
}

/* Web端适配 */
@media screen and (min-width: 1425px) {
  .wrap {
    max-width: 1000px;
    padding: 0 20px;
  }
}
.mb {
  margin-bottom: 14px !important;
}

.mr {
  margin-right: 14px !important;
}

.el-table .cell,
.el-table--border td:first-child .cell {
  padding: 0 !important;
  text-align: center;
}

.el-table td,
.el-table th {
  padding: 0 !important;
}

.data-table .el-input-number {
  width: 100% !important;
  display: inline-block;
}

.el-input-number.is-controls-right .el-input__inner {
  padding: 3px 30px 3px 0px !important;
}

.el-divider.el-divider--horizontal {
  margin: 10px 0 !important;
}

.alert {
  cursor: pointer;
}

.active {
  color: cornflowerblue;
}

.el-tag107 {
  margin: 0 11px 0 0;
}

.el-checkbox-group104 {
  margin: 0 0 0 9px;
}

/* 历史查询列表样式 */
.history-query-list {
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.history-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.history-items {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* 移动端历史查询标签样式 */
/* @media screen and (max-width: 768px) { */
.history-query-list {
  padding: 8px;
}

.history-items {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 6px;
}

.history-tag {
  white-space: normal !important;
  height: auto !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  font-size: 14px !important;
  cursor: pointer;
}
/* } */

/* Checkbox 响应式样式 */
.checkbox-group {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px;
}

.checkbox-item {
  margin-right: 0 !important;
  flex: 0 0 auto;
}

/* 移动端 checkbox 样式 */
@media screen and (max-width: 768px) {
  .checkbox-item {
    min-width: calc(50% - 4px);
    flex: 0 0 calc(50% - 4px);
  }
}

/* 平板和 Web 端 checkbox 样式 */
@media screen and (min-width: 769px) {
  .checkbox-item {
    width: 140px;
  }
}

/* 标题样式 */
.title-header {
  display: flex;
  justify-content: center;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  .title-header {
    padding: 12px;
    font-size: 16px;
  }
}

/* 按钮组响应式 */
@media screen and (max-width: 768px) {
  .mb .el-button {
    width: 100%;
    margin-bottom: 8px;
  }
}

/* 表格响应式样式 */
@media screen and (max-width: 768px) {
  .data-table {
    font-size: 12px;
  }

  .data-table .el-table__body-wrapper {
    overflow-x: auto;
  }

  .data-table .el-table-column {
    min-width: 80px !important;
  }

  .data-table .el-table__header-wrapper th {
    padding: 8px 4px !important;
    font-size: 12px;
  }

  .data-table .el-table__body-wrapper td {
    padding: 8px 4px !important;
    font-size: 12px;
  }
}

/* Radio 组响应式 */
@media screen and (max-width: 768px) {
  .mb .el-radio {
    display: block;
    margin-bottom: 8px;
  }
}

/* 下拉菜单响应式 */
@media screen and (max-width: 768px) {
  .el-dropdown-menu {
    max-width: calc(100vw - 20px);
  }

  .el-dropdown-menu__item {
    padding: 10px 15px;
    font-size: 14px;
    white-space: normal;
    word-break: break-word;
  }
}

/* Select 下拉框响应式 */
@media screen and (max-width: 768px) {
  .el-select {
    font-size: 14px;
  }

  .el-select-dropdown__item {
    padding: 10px 15px;
    font-size: 14px;
  }
}

/* 全局移动端优化 */
@media screen and (max-width: 768px) {
  * {
    -webkit-tap-highlight-color: transparent;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

/* 柱状图样式 */
.bar-chart-container {
  padding: 8px 0;
  min-width: 180px;
}

.bar-chart-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 12px;
}

.bar-chart-item:last-child {
  margin-bottom: 0;
}

.bar-chart-label {
  min-width: 80px;
  font-size: 11px;
  color: #606266;
  text-align: left;
  margin-right: 8px;
  flex-shrink: 0;
}

.bar-chart-wrapper {
  flex: 1;
  height: 16px;
  background-color: #f0f2f5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  min-width: 60px;
}

.bar-chart-bar {
  height: 100%;
  background: linear-gradient(90deg, #409eff 0%, #66b1ff 100%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 6px;
  transition: width 0.3s ease;
  min-width: 30px;
}

.bar-chart-value {
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 移动端柱状图样式 */
@media screen and (max-width: 768px) {
  .bar-chart-container {
    padding: 6px 0;
    min-width: 150px;
  }

  .bar-chart-item {
    margin-bottom: 6px;
    font-size: 11px;
  }

  .bar-chart-label {
    min-width: 70px;
    font-size: 10px;
    margin-right: 6px;
  }

  .bar-chart-wrapper {
    height: 14px;
    min-width: 50px;
  }

  .bar-chart-bar {
    padding-right: 4px;
    min-width: 25px;
  }

  .bar-chart-value {
    font-size: 10px;
  }
}
</style>

<style>
html,
.el-table {
  /* background: #c5ffe5 !important;
	background: linear-gradient(to bottom, #c5ffe5, #bcffff); */
}

.bold {
  font-weight: bold;
}

.red {
  color: #dc143c;
}

.green {
  color: #69c16e;
}

#C1 .g2-tooltip {
  left: -600px !important;
  top: -240px !important;
}

#C3 .g2-tooltip {
  left: -600px !important;
}

.tooltip-item {
  flex: none;
  /* width: max-content; */
  overflow: hidden;
  white-space: nowrap;
}

.cyb .el-table .caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 34px;
  width: 10px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}

.auto .el-tag--small {
  padding: 0;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
}

.auto .el-tag--small span {
  flex: 1;
  width: 79px;
  overflow: hidden;
}

.auto .el-tag--small .el-icon-close {
  flex: none;
  transform: scale(1);
  font-size: 16px;
  right: 0;
}

.new-item {
  background: #fcf6ed;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mini {
  font-size: 12px;
  line-height: 1;
}

.ml {
  margin-left: 14px;
}

.icon-rz {
  color: #458ad9;
  display: inline-block;
  padding: 0 0.2px;
  border-radius: 0.1px;
  transform: scale(0.8);
  line-height: 0.9;
}

.star-icon {
  color: #458ad9;
  font-size: 22px;
  cursor: pointer;
}

.icon {
  font-size: 12px;
  cursor: pointer;
}

.div104 {
  font-size: 12px;
}

.cyb {
  display: flex;
  padding-bottom: 40px;
  font-size: 14px;
  padding-left: 6px;
  min-height: 100vh;
  overflow-x: auto;
}

.el-table__body tr.current-row > td {
  background-color: #d5e4f7 !important;
}

.setter .el-checkbox {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #222222 !important;
  padding: 0 !important;
  margin-right: 6px;
}

.setter .el-radio {
  font-size: 12px !important;
  font-weight: 400 !important;
  color: #222222 !important;
  padding: 0 !important;
  margin-right: 6px;
}

.setter .el-radio__label {
  font-size: 12px;
  padding-left: 0px;
}

.setter .el-checkbox__label {
  font-size: 12px !important;
  font-weight: 400 !important;
  padding: 0 !important;
  color: #222222 !important;
}

.cyb .el-table .sort-caret {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 0px;
}

.cyb .el-table .sort-caret.ascending {
  /* border: 8px solid transparent;
	border-bottom-color: #C0C4CC;
	top: -1px;
	left: 6px; */
}

.cyb .el-table .sort-caret.descending {
  /* border: 8px solid transparent;
	border-top-color: #C0C4CC;
	bottom: -1px;
	left: 6px; */
}

.el-table th > .cell {
  padding: 0;
  min-width: 0;
  box-sizing: border-box;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
}

.right-part {
  flex: 1;
  padding: 12px;
  /* height: calc(100vh - 41px); */
}

.chart-box2 {
  /* background: #0d0d0d; */
  /* margin-bottom: 30px; */
  /* width: min-content; */
  /* margin-left: 20px; */
  /* min-height: 260px;
	min-width: 210px; */
  /* border: 1px solid #C0C4CC; */
}

.store-select {
  width: 66px;
}

.store-select .el-input--mini .el-input__inner {
  padding: 0;
  line-height: 24px;
  height: 24px;
}

.store-select .el-input__suffix {
  display: none;
}

.el-slider__runway {
  margin: 3px 0 !important;
}
</style>
